import { render, staticRenderFns } from "./TeachersReport.vue?vue&type=template&id=79e70b4e"
import script from "./TeachersReport.vue?vue&type=script&lang=js"
export * from "./TeachersReport.vue?vue&type=script&lang=js"
import style0 from "./TeachersReport.vue?vue&type=style&index=0&id=79e70b4e&prod&lang=scss"
import style1 from "./TeachersReport.vue?vue&type=style&index=1&id=79e70b4e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports